const env = require("../../config.js").default;
const common = require("./common.jsx");

class customConfig{
  async init(){
    var localConfig, requestedData = [], doRequest = false;
    this.frontendCustomization = {};
    this.frontendCustomization.header="header_centrato";

    var loggedIn = await common.verifyLogin(true);

    if(!common.get_localStorage("customConfig") || common.get_localStorage("customConfig")===null || common.get_localStorage("customConfig")===undefined || common.get_localStorage("customConfig")==="" || !loggedIn){
      doRequest = true;
      requestedData.push("customConfig");
    }else{
      localConfig = JSON.parse(common.get_localStorage("customConfig"));
      for (var index in localConfig){
        this[index] = localConfig[index];
      }
    }

    if(!common.get_localStorage("labels") || common.get_localStorage("labels")===null || common.get_localStorage("labels")===undefined || common.get_localStorage("labels")===""  || !loggedIn){
      doRequest = true;
      requestedData.push("labels");
    }else{
      env.labels = JSON.parse(common.get_localStorage("labels"));
    }

    if(doRequest)
      return await this.getAppVar(requestedData);
    else {
      return true;
    }
  }

  async getAppVar(requestedData){
    return await common.apiCall(env.BACKEND + "app_var", "GET", {csoft: env.CSOFT}, false)
    .then(backendConfig=>{
      if(backendConfig.error === false){
        for (var index in backendConfig){
          if(index !== "error")
            this[index] = backendConfig[index];
        }

        delete backendConfig['labels'];
        env.labels = this["labels"];
        if(backendConfig && backendConfig !== undefined && backendConfig !== null && Array.isArray(backendConfig) && backendConfig.length > 0){
          common.set_localStorage("customConfig", JSON.stringify(backendConfig));
          common.set_localStorage("labels", JSON.stringify(this["labels"]));
        }

        return backendConfig
      }
      return false
    });
  }

  async getUserInfo() {
    return await common.apiCall(env.BACKEND + "get_user_info", "GET", {}, true)
    .then(userInfo=>{
      if(userInfo.error === false){
        for (var index in userInfo){
          if(index !== "error")
            this[index] = userInfo[index];
        }
      }
    });
  }

}

export default customConfig;
